module.exports = __webpack_public_path__ + "img/hc-3dview.3161cf66.png";